import { useMemo } from 'react';

import type { AutoCompleteConfig } from '@components/NextForms/TextInput';
import type { Payee } from '@models/next/PaymentSlip';
import type { MobxZodField } from '@monoid-dev/mobx-zod-form';
import type { ZodNumber, ZodString } from 'zod';

export type PayeeIdAutoComplete = AutoCompleteConfig<{
  id: number;
  name_en: string;
  partner_id: number | null;
}>;

export interface PayeeIdAutoCompleteOptions {
  payees: Payee[];
  idField: MobxZodField<ZodNumber>;
  nameEnField: MobxZodField<ZodString>;
}

export const usePayeeIdAutoComplete = ({
  payees,
  idField,
  nameEnField,
}: PayeeIdAutoCompleteOptions): PayeeIdAutoComplete => {
  return {
    autoCompleteOptions: useMemo(
      () =>
        payees.map((payee) => ({
          label: payee.name_en,
          value: payee,
        })),
      [],
    ),
    filter: (value, options) =>
      options.filter((option) =>
        option.value.name_en.toUpperCase().includes(String(value).toUpperCase()),
      ),
    onSelect: (option) => {
      idField.setOutput(option.value.id);
      nameEnField.setOutput(option.value.name_en);
    },
  };
};
